import React from 'react';
import Avatar from 'react-avatar';
import instituteSVG from '../../assets/img/userIcon.svg';

const DisplaySelectedFile = ({ name, src, size, ...props }) => {
  return <Avatar name={name} round={true} size={size || 32} src={src || instituteSVG} />;
};

export default DisplaySelectedFile;
